import type { GetManagementResponse } from '@/domains/academicRisk/academicRiskManagement.entity';
import type { AcademicRiskManagementRepository } from '@/domains/academicRisk/academicRiskManagement.repository';

/**
 * Use Case para obtener gestión de riesgo académico por código de incorporación
 *
 * Responsabilidades:
 * - Obtener datos de gestión desde el repositorio
 * - Actuar como intermediario entre dominio e infraestructura
 */
export class GetAcademicRiskManagementUseCase {
  private academicRiskRepository: AcademicRiskManagementRepository;

  /**
   * Inicializa el UseCase con el repositorio necesario
   * @param academicRiskRepository - Repositorio para operaciones de gestión de riesgo académico
   */
  constructor(academicRiskRepository: AcademicRiskManagementRepository) {
    this.academicRiskRepository = academicRiskRepository;
  }

  /**
   * Ejecuta la obtención de una gestión de riesgo académico
   * @param cod_incorporacion_accion - Código de incorporación de acción asociada
   * @throws Error si la obtención falla
   */
  async execute(
    cod_incorporacion_accion: number,
  ): Promise<GetManagementResponse> {
    return await this.academicRiskRepository.getManagement(
      cod_incorporacion_accion,
    );
  }
}
